import { render, staticRenderFns } from "./bus.vue?vue&type=template&id=07014ffe&scoped=true&"
import script from "./bus.vue?vue&type=script&lang=js&"
export * from "./bus.vue?vue&type=script&lang=js&"
import style0 from "./bus.vue?vue&type=style&index=0&id=07014ffe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07014ffe",
  null
  
)

export default component.exports